import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  fill: "currentColor",
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "100",
  y1: "617.768",
  x2: "100",
  y2: "753.575",
  gradientTransform: "translate(0 -566)"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M10 86.7c0-41.1 38.1-74.2 84.6-74.2 46.6 0 84.7 33.1 84.1 74.7 0 41.1-38.1 74.3-84.7 74.3-6 0-11.8-.6-17.8-1.5L53 175.4c-.2 0-.5.1-.8.2-.5.1-1.1.3-1.6.3-2.5 0-4.5-2-4.5-5v-23C24.3 134.3 10 111.7 10 86.7zm36.6 2c.1 5.6 4.5 10 9.9 10s9.8-4.5 9.9-10c-.1-5.6-4.5-10-9.9-10s-9.9 4.4-9.9 10zm43.6 9c3 2 6.9 2 9.9 0 2.9-2 4.9-5 4.9-9-.1-5.6-4.5-10-9.9-10s-9.9 4.4-9.9 10c.1 3.6 2 7 5 9zm32.1-9c.1 5.6 4.5 10 9.9 10s9.8-4.5 9.9-10c-.1-5.6-4.5-10-9.9-10s-9.9 4.4-9.9 10zm58 17.1.5.5c5.9 6.9 9.3 15.8 9.2 26 0 15.8-8.9 29.6-22.6 38v14.3c0 2-1.4 2.9-2.9 2.9-.3 0-.6-.1-.8-.3-.2-.1-.5-.2-.7-.2l-14.2-9.8c-3.9 1-7.3 1-11.3 1-14.8 0-28.1-4.9-37.4-13.3 5.9-.5 11.8-1 17.7-2.5 0 0 20.4-4.1 33.3-13.4 12-8.6 22-25.6 23.9-28.9 2.3-4.2 3.7-8.8 5.1-13.4 0-.3.1-.6.2-.9z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}